import React from 'react'
import { useLocation } from 'react-router-dom'

import AnalyticsModule from '../../../widgets/analytics'

const Analytics = ({ client, userId, userData }) => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const co_user_id = queryParams.get('user_id') || userId

  // the viewed customer — the module emulates exactly what they see in their own app
  const viewedUser = {
    id: (userData && userData._id) || co_user_id,
    email: userData?.email,
    name: userData?.name,
    user_type: userData?.user_type || 'individual',
    user_role: userData?.user_role || 'owner',
    org_id: userData?.org_id
  }

  return (
    <div>
      <AnalyticsModule
        client={client}
        viewedUser={viewedUser}
      />
    </div>
  )
}

export default Analytics
